import { Components, Theme } from '@mui/material';

export const skeletonTheme: Components<Theme> = {
  MuiSkeleton: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor:
          theme.palette.mode === 'dark'
            ? theme.palette.text.fourth || 'rgba(255, 255, 255, 0.13)'
            : theme.palette.text.fifth || 'rgba(0, 0, 0, 0.11)',

        // Ensure the skeleton animates properly in both modes
        '&::after': {
          background: `linear-gradient(90deg, transparent, ${
            theme.palette.mode === 'dark'
              ? theme.palette.text.third || 'rgba(255, 255, 255, 0.2)'
              : 'rgba(0, 0, 0, 0.04)'
          }, transparent)`,
        },
      }),

      // Text variant specific styling
      text: ({ theme }) => ({
        backgroundColor:
          theme.palette.mode === 'dark'
            ? theme.palette.text.fourth || 'rgba(255, 255, 255, 0.13)'
            : theme.palette.text.fifth || 'rgba(0, 0, 0, 0.11)',
      }),

      // Rectangular variant specific styling
      rectangular: ({ theme }) => ({
        backgroundColor:
          theme.palette.mode === 'dark'
            ? theme.palette.text.fourth || 'rgba(255, 255, 255, 0.13)'
            : theme.palette.text.fifth || 'rgba(0, 0, 0, 0.11)',
      }),

      // Rounded variant specific styling
      rounded: ({ theme }) => ({
        backgroundColor:
          theme.palette.mode === 'dark'
            ? theme.palette.text.fourth || 'rgba(255, 255, 255, 0.13)'
            : theme.palette.text.fifth || 'rgba(0, 0, 0, 0.11)',
      }),

      // Circular variant specific styling
      circular: ({ theme }) => ({
        backgroundColor:
          theme.palette.mode === 'dark'
            ? theme.palette.text.fourth || 'rgba(255, 255, 255, 0.13)'
            : theme.palette.text.fifth || 'rgba(0, 0, 0, 0.11)',
      }),
    },
  },
};
